import React from "react";
import Loader from "../../../components/Loader";
import usePagination from "../../../hooks/usePagination";
import Pagination from "../../../components/Pagination/Pagination";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import { useTableResponsive } from "../../../hooks/useTableResponsive";

const MeritoriousScholarship = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: scholarshipData = [], isLoading: isScholarshipLoading } =
    useGetProtectedApiDataQuery({
      url: "meritorious_scholarship",
      lang: languageType,
    });

  useTableResponsive(scholarshipData);

  function calculateFieldTotals(data) {
    // Initialize an object to store totals
    const totals = {};

    // Loop through each object in the data array
    data.forEach((item) => {
      // Loop through each field in the current item
      for (const field in item) {
        // Convert the field value to a number (if empty, default to 0)
        const value = parseFloat(item[field]) || 0;

        // Check if this field already exists in totals; if not, initialize it
        const totalFieldName = `${field}_total`;
        totals[totalFieldName] = (totals[totalFieldName] || 0) + value;
      }
    });

    return totals;
  }

  const { getText } = useLanguageTranslation();

  const { currentItems, currentPage, totalPages, handlePageChange } =
    usePagination(scholarshipData, 4);

  if (isScholarshipLoading) {
    return <Loader />;
  }
  return (
    <>
      <div className="container">
        <div className="title-sec">
          <h2>{getText("Meritorious Scholarship", "मेरिटोरियस स्कॉलरशिप")}</h2>
        </div>
      </div>
      <div className="responsive_table">
        <table className="table table-striped custom-table table-bordered">
          <thead>
            <tr>
              <th colSpan="13">
                {getText(
                  "Year wise NEEPCO Meritorious Scholarship awarded to economically backward students at various project/plant locations :-",
                  "वर्षवार NEEPCO मेरिटोरियस स्कॉलरशिप विभिन्न परियोजना/प्लांट स्थानों पर आर्थिक रूप से पिछड़े छात्रों को प्रदान की गई :-"
                )}
              </th>
            </tr>
            <tr>
              <th className="no-wrap-td" rowSpan="2">
                {getText("Year", "वर्ष")}
              </th>
              <th>{getText("AGBP, Assam", "AGBP, असम")}</th>
              <th>{getText("AGTP, Tripura", "AGTP, त्रिपुरा")}</th>
              <th>{getText("KHEP, Assam", "KHEP, असम")}</th>
              <th>{getText("Guwahati, Assam", "गुवाहाटी, असम")}</th>
              <th>{getText("TGBP, Tripura", "TGBP, त्रिपुरा")}</th>
              <th>{getText("DHEP, Nagaland", "DHEP, नागालैंड")}</th>
              <th>
                {getText("RHEP, Arunachal Pradesh", "RHEP, अरुणाचल प्रदेश")}
              </th>
              <th>
                {getText(
                  "KaHEP (KPC & BDC), Arunachal Pradesh",
                  "KaHEP (KPC & BDC), अरुणाचल प्रदेश"
                )}
              </th>
              <th>
                {getText("PHEP, Arunachal Pradesh", "PHEP, अरुणाचल प्रदेश")}
              </th>
              <th>{getText("TrHEP, Mizoram", "TrHEP, मिजोरम")}</th>
              <th>{getText("MaHEP, Meghalaya", "MaHEP, मेघालय")}</th>
              <th rowSpan="2">{getText("Grand Total", "कुल योग")}</th>
            </tr>
            <tr>
              <th>{getText("No. of students", "छात्रों की संख्या")}</th>
              <th>{getText("No. of students", "छात्रों की संख्या")}</th>
              <th>{getText("No. of students", "छात्रों की संख्या")}</th>
              <th>{getText("No. of students", "छात्रों की संख्या")}</th>
              <th>{getText("No. of students", "छात्रों की संख्या")}</th>
              <th>{getText("No. of students", "छात्रों की संख्या")}</th>
              <th>{getText("No. of students", "छात्रों की संख्या")}</th>
              <th>{getText("No. of students", "छात्रों की संख्या")}</th>
              <th>{getText("No. of students", "छात्रों की संख्या")}</th>
              <th>{getText("No. of students", "छात्रों की संख्या")}</th>
              <th>{getText("No. of students", "छात्रों की संख्या")}</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((item, index) => (
              <tr key={index}>
                <td className="no-wrap-td" data-key={getText("Year", "वर्ष")}>
                  <strong>{item.title}</strong>
                </td>
                <td data-key={getText("AGBP, Assam", "AGBP, असम")}>
                  {item?.field_agbp_assam_no_of_students}
                </td>
                <td data-key={getText("AGTP, Tripura", "AGTP, त्रिपुरा")}>
                  {item.field_agtp_tripura}
                </td>
                <td data-key={getText("KHEP, Assam", "KHEP, असम")}>
                  {item.field_khep_assam}
                </td>
                <td data-key={getText("Guwahati, Assam", "गुवाहाटी, असम")}>
                  {item.field_guwahati_assam}
                </td>
                <td data-key={getText("TGBP, Tripura", "TGBP, त्रिपुरा")}>
                  {item.field_tgbp_tripura}
                </td>
                <td data-key={getText("DHEP, Nagaland", "DHEP, नागालैंड")}>
                  {item.field_dhep_nagaland}
                </td>
                <td
                  data-key={getText(
                    "RHEP, Arunachal Pradesh",
                    "RHEP, अरुणाचल प्रदेश"
                  )}
                >
                  {item.field_rhep_arunachal_pradesh}
                </td>
                <td
                  data-key={getText(
                    "KaHEP (KPC & BDC), Arunachal Pradesh",
                    "KaHEP (KPC & BDC), अरुणाचल प्रदेश"
                  )}
                >
                  {item.field_kahep_kpc_bdc_arunachal_pr}
                </td>
                <td
                  data-key={getText(
                    "PHEP, Arunachal Pradesh",
                    "PHEP, अरुणाचल प्रदेश"
                  )}
                >
                  {item.field_phep_arunachal_prades}
                </td>
                <td data-key={getText("TrHEP, Mizoram", "TrHEP, मिजोरम")}>
                  {item.field_trhep_mizoram}
                </td>
                <td data-key={getText("MaHEP, Meghalaya", "MaHEP, मेघालय")}>
                  {item.field_mahep_meghalaya}
                </td>
                <td data-key={getText("Grand Total", "कुल योग")}>
                  {parseFloat(item.field_agbp_assam_no_of_students || 0) +
                    parseFloat(item.field_agtp_tripura || 0) +
                    parseFloat(item.field_khep_assam || 0) +
                    parseFloat(item.field_guwahati_assam || 0) +
                    parseFloat(item.field_tgbp_tripura || 0) +
                    parseFloat(item.field_dhep_nagaland || 0) +
                    parseFloat(item.field_rhep_arunachal_pradesh || 0) +
                    parseFloat(item.field_kahep_kpc_bdc_arunachal_pr || 0) +
                    parseFloat(item.field_phep_arunachal_prades || 0) +
                    parseFloat(item.field_trhep_mizoram || 0) +
                    parseFloat(item.field_mahep_meghalaya || 0)}
                </td>
              </tr>
            ))}
            {currentPage === totalPages && (
              <tr>
                <td>
                  <strong>Total</strong>
                </td>
                <td>
                  <strong>
                    {
                      calculateFieldTotals(scholarshipData)
                        .field_agbp_assam_no_of_students_total
                    }
                  </strong>
                </td>
                <td>
                  <strong>
                    {
                      calculateFieldTotals(scholarshipData)
                        .field_agtp_tripura_total
                    }
                  </strong>
                </td>
                <td>
                  <strong>
                    {
                      calculateFieldTotals(scholarshipData)
                        .field_khep_assam_total
                    }
                  </strong>
                </td>
                <td>
                  <strong>
                    {
                      calculateFieldTotals(scholarshipData)
                        .field_guwahati_assam_total
                    }
                  </strong>
                </td>
                <td>
                  <strong>
                    {
                      calculateFieldTotals(scholarshipData)
                        .field_tgbp_tripura_total
                    }
                  </strong>
                </td>
                <td>
                  <strong>
                    {
                      calculateFieldTotals(scholarshipData)
                        .field_dhep_nagaland_total
                    }
                  </strong>
                </td>
                <td>
                  <strong>
                    {
                      calculateFieldTotals(scholarshipData)
                        .field_kahep_kpc_bdc_arunachal_pr_total
                    }
                  </strong>
                </td>
                <td>
                  <strong>
                    {
                      calculateFieldTotals(scholarshipData)
                        .field_phep_arunachal_prades_total
                    }
                  </strong>
                </td>
                <td>
                  <strong>
                    {
                      calculateFieldTotals(scholarshipData)
                        .field_trhep_mizoram_total
                    }
                  </strong>
                </td>
                <td>
                  <strong>
                    {
                      calculateFieldTotals(scholarshipData)
                        .field_mahep_meghalaya_total
                    }
                  </strong>
                </td>
                <td>
                  <strong>
                    {
                      calculateFieldTotals(scholarshipData)
                        .field_mahep_meghalaya_total
                    }
                  </strong>
                </td>
                <td>
                  <strong>
                    {
                      calculateFieldTotals(scholarshipData)
                        .field_grand_total_total
                    }
                  </strong>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </>
  );
};

export default MeritoriousScholarship;
